import * as React from "react";
import type { SVGProps } from "react";
const SvgSnowheight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#snowheight_svg__a)">
      <path d="M16.47 9a1 1 0 0 1-.71-.3l-2.21-2.21a1 1 0 0 1 0-1.41A1 1 0 0 1 15 5l1.5 1.5L18 5a1 1 0 1 1 1.42 1.41l-2.21 2.21a1 1 0 0 1-.74.38M18.68 19.26A1 1 0 0 1 18 19l-1.5-1.5L15 19a1 1 0 0 1-1.42 0 1 1 0 0 1 0-1.41l2.21-2.21a1 1 0 0 1 1.42 0l2.21 2.21a1 1 0 0 1 0 1.41 1 1 0 0 1-.74.26" />
      <path d="M16.47 20a1 1 0 0 1-1-1V5a1 1 0 1 1 2 0v14a1 1 0 0 1-1 1M12.15 18.05a.8.8 0 0 1-.26 0 1 1 0 0 1-.7-1.22l.55-2.06-2.06-.55A1 1 0 0 1 9 13a1 1 0 0 1 1.22-.71l3 .81a1 1 0 0 1 .71 1.23l-.81 3a1 1 0 0 1-.97.72M23 11.78h-.26l-3-.81a1 1 0 0 1-.71-1.23l.81-3a.999.999 0 1 1 1.93.51l-.54 2.06 2 .55A1 1 0 0 1 24 11a1 1 0 0 1-1 .78" />
      <path d="M10.41 16.5a1 1 0 0 1-.5-1.87l12.12-7A1 1 0 0 1 23.4 8a1 1 0 0 1-.37 1.37l-12.12 7a1 1 0 0 1-.5.13M20.79 18.05a1 1 0 0 1-1-.75l-.81-3a1 1 0 0 1 .71-1.23l3-.81A1 1 0 0 1 24 13a1 1 0 0 1-.71 1.22l-2 .55.54 2.06a1 1 0 0 1-.7 1.22.8.8 0 0 1-.34 0M9.94 11.78a1 1 0 0 1-.9-1.494 1 1 0 0 1 .6-.466l2.06-.55-.55-2.06a1 1 0 0 1 1.463-1.121 1 1 0 0 1 .467.611l.81 3a1 1 0 0 1-.71 1.23l-3 .81a1 1 0 0 1-.24.04" />
      <path d="M22.53 16.5a1 1 0 0 1-.5-.13l-12.12-7a1 1 0 0 1-.113-1.666 1 1 0 0 1 1.113-.074l12.12 7a1 1 0 0 1-.5 1.87M1 8a1 1 0 0 1-.71-1.71l3-3a1 1 0 0 1 1.42 0 1 1 0 0 1 0 1.42l-3 3A1 1 0 0 1 1 8" />
      <path d="M7 8a1 1 0 0 1-.71-.29l-3-3a1 1 0 0 1 0-1.42 1 1 0 0 1 1.42 0l3 3A1 1 0 0 1 7 8M4 21a.999.999 0 0 1-.71-1.71l3-3a1 1 0 0 1 1.639.325 1 1 0 0 1-.22 1.095l-3 3A1 1 0 0 1 4 21" />
      <path d="M4 21a1 1 0 0 1-.71-.29l-3-3a1 1 0 0 1 0-1.42 1 1 0 0 1 1.42 0l3 3A1 1 0 0 1 4 21" />
      <path d="M4 19a1 1 0 0 1-1-1V6a1 1 0 0 1 2 0v12a1 1 0 0 1-1 1" />
    </g>
    <defs>
      <clipPath id="snowheight_svg__a">
        <path fill="#fff" d="M0 3h24v18H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSnowheight;
